var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _ from 'lodash';
import { CreateAppSheetSubTitle, CreateAppSheetTitle, Container, TemplateInfoMainContainer, CustomerSuccessContainer, AppspotrLogo, CustomerSuccessHeader, CustomerSuccessText, CustomerSuccessBoldText, CustomerLogoHeader, TemplateInfoContainer, AppIsReadyContainer, AppIsReadyText, AppIsReadyImg, AppIsReadyImgContainer, AppIsReadyInnerContainer, ResponsiveContainer, MaxWidthContainer, TemplateEnvContainerSpacer, TemplateContentRow, TemplateInfoHeader, EnvInputContainer, TemplateEnvContent, TemplateEnvDivider, } from '../styles';
import environment from '../../../images/environment.png';
import EnvInput from '../components/EnvInput';
import { selectAppCreationFlow } from '@project/store/createAppFlow/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { setEnvStatus } from '../../../store/createAppFlow/actions';
var CreateAppEnvironmentVariables = function () {
    var dispatch = useDispatch();
    var environmentData = useSelector(selectAppCreationFlow).environmentData;
    var getCategorizedInputs = function (data) {
        var _a;
        var sections = [];
        (_a = (data || [])) === null || _a === void 0 ? void 0 : _a.map(function (d) {
            if (_.find(sections, function (s) {
                return (s === null || s === void 0 ? void 0 : s.name) === (d === null || d === void 0 ? void 0 : d.section);
            }) === undefined) {
                var copyOfElements = [];
                copyOfElements === null || copyOfElements === void 0 ? void 0 : copyOfElements.push(d);
                sections === null || sections === void 0 ? void 0 : sections.push({
                    id: d === null || d === void 0 ? void 0 : d.id,
                    name: d === null || d === void 0 ? void 0 : d.section,
                    elements: copyOfElements,
                });
            }
            else {
                var sCopy_1 = _.find(sections, function (s) {
                    return (s === null || s === void 0 ? void 0 : s.name) === (d === null || d === void 0 ? void 0 : d.section);
                });
                var indexOfSection = sections === null || sections === void 0 ? void 0 : sections.findIndex(function (s) { return (s === null || s === void 0 ? void 0 : s.id) === sCopy_1.id; });
                var copyOfSCopyElements = sCopy_1 === null || sCopy_1 === void 0 ? void 0 : sCopy_1.elements;
                copyOfSCopyElements.push(d);
                sections[indexOfSection].elements = copyOfSCopyElements;
            }
        });
        return sections;
    };
    var checkIfAllEnvsAreComplete = function () {
        environmentData.map(function (d) {
            if (d.required) {
                if (Object.keys(d.value).includes('value')) {
                    if (d.value.value === '' || d.value.value === undefined) {
                        dispatch(setEnvStatus(true));
                    }
                }
                else {
                    if (d.value === '' || d.value === undefined) {
                        dispatch(setEnvStatus(true));
                    }
                }
            }
        });
    };
    checkIfAllEnvsAreComplete();
    return (_jsx(ResponsiveContainer, __assign({ noHeight: true, marginTop: 40 }, { children: _jsx(MaxWidthContainer, { children: _jsxs(TemplateInfoContainer, { children: [_jsxs(TemplateInfoMainContainer, { children: [_jsxs(Container, { children: [_jsx(CreateAppSheetSubTitle, { children: "Adding the final touches" }), _jsx(CreateAppSheetTitle, { children: "Enhance the app by adding additional details" })] }), (getCategorizedInputs(environmentData) || []).map(function (input) {
                                var _a;
                                return (_jsxs(TemplateEnvContainerSpacer, { children: [_jsxs(TemplateContentRow, { children: [_jsx(TemplateInfoHeader, { children: input.name }), _jsx(EnvInputContainer, { children: _jsx(TemplateEnvContent, { children: (_a = input === null || input === void 0 ? void 0 : input.elements) === null || _a === void 0 ? void 0 : _a.map(function (i) {
                                                            return _jsx(EnvInput, { input: i }, i === null || i === void 0 ? void 0 : i.id);
                                                        }) }) })] }), _jsx(TemplateEnvDivider, {})] }, input.id));
                            })] }), _jsxs(AppIsReadyContainer, { children: [_jsxs(AppIsReadyInnerContainer, { children: [_jsx(AppIsReadyText, { children: "Your app is almost ready!" }), _jsx(AppIsReadyImgContainer, { children: _jsx(AppIsReadyImg, { src: environment, alt: "environment" }) }), _jsxs(AppIsReadyText, { children: ["Providing this data will enable us to customize your app even further by personalizing app functionality. ", _jsx("br", {}), " ", _jsx("br", {}), "You can always do this later."] })] }), _jsxs(AppIsReadyInnerContainer, __assign({ marginTop: true }, { children: [_jsx(AppIsReadyText, { children: "Need more help?" }), _jsxs(CustomerSuccessContainer, { children: [_jsxs(CustomerLogoHeader, { children: [_jsx(AppspotrLogo, {}), _jsx(CustomerSuccessHeader, { children: "Customer success team" })] }), _jsx(CustomerSuccessText, { children: "Drop us an email and reach out to us at" }), _jsx(CustomerSuccessBoldText, { children: "support@appspotr.com" })] })] }))] })] }) }) })));
};
export default CreateAppEnvironmentVariables;
